export default __webpack_public_path__ + "static/media/susie8.ffd1f71b.jpg";